var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChestO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 181,
    viewBox: "0 0 212 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1992 6.24152C71.4221 5.42493 73.0478 5.41538 74.9801 5.91307C75.921 18.3261 87.6617 24.9865 106.088 24.9865C124.321 24.9865 136.106 18.4676 137.272 6.30579C138.432 5.70696 141.515 5.38536 142.789 6.65467C142.789 6.65789 142.789 6.66112 142.789 6.66434C151.326 9.44543 159.892 12.3777 167.256 14.8987C170.616 16.049 173.727 17.1139 176.47 18.0394C192.387 23.4108 201.959 68.1358 205.64 99.0204C201.153 103.513 188.813 109.06 164.672 109.06C164.672 111.296 164.614 127.996 164.556 144.771L164.556 144.783L164.556 144.827C164.497 161.737 164.439 178.707 164.439 181.001H106.001H106H47.7224C47.7224 178.705 47.6099 161.814 47.4979 144.995L47.4979 144.991L47.4979 144.989C47.3868 128.313 47.2763 111.709 47.2763 109.473C23.1357 109.473 10.8482 103.513 6.36133 99.0204C10.0429 68.1358 19.6142 23.4108 35.5321 18.0394C38.275 17.1139 41.3849 16.0492 44.745 14.899C52.3933 12.2807 61.3377 9.21878 70.1995 6.34336C70.1993 6.30944 70.1992 6.27549 70.1992 6.24152Z",
    fill: "#9A9A9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_725_50841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 200,
    height: 177
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1992 6.24196C71.4221 5.42537 73.0478 5.41583 74.9801 5.91351C75.921 18.3265 87.6617 24.987 106.088 24.987C124.321 24.987 136.106 18.468 137.272 6.30624C138.432 5.7074 141.515 5.3858 142.789 6.65511C142.789 6.65833 142.789 6.66156 142.789 6.66478C151.326 9.44587 159.892 12.3782 167.256 14.8992C170.616 16.0494 173.727 17.1143 176.47 18.0399C192.387 23.4112 201.959 68.1363 205.64 99.0209C201.153 103.514 188.813 109.06 164.672 109.06C164.672 111.296 164.614 127.996 164.556 144.772L164.556 144.783L164.556 144.827C164.497 161.737 164.439 178.708 164.439 181.001H106.001H106H47.7224C47.7224 178.706 47.6099 161.815 47.4979 144.995L47.4979 144.991L47.4979 144.99C47.3868 128.314 47.2763 111.71 47.2763 109.473C23.1357 109.473 10.8482 103.514 6.36133 99.0209C10.0429 68.1363 19.6142 23.4112 35.5321 18.0399C38.275 17.1143 41.3849 16.0497 44.745 14.8994C52.3933 12.2812 61.3377 9.21922 70.1995 6.3438C70.1993 6.30988 70.1992 6.27593 70.1992 6.24196Z",
    fill: "#D3D3D3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_725_50841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 181L6 146L205 146L205 181L6 181Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 110L6 74L205 74L205 110L6 110Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 40L6 5.00001L205 5L205 40L6 40Z",
    fill: "#464646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestO);
export default __webpack_public_path__ + "static/media/Chest O.dbd39a451904ec05e338d1b2ca5f5ee9.svg";
export { ForwardRef as ReactComponent };